import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-globe',
  templateUrl: './icon-globe.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconGlobeComponent {}
